module.exports = __webpack_public_path__ + "img/TOCTemp5.ba6fc0e5.png";